import { ENV } from '../../config/env';

const BASE_URL = ENV.VITE_BDAPI_BASE_URL;

export interface BdDivision {
  id: string;
  name: string;
  bn_name: string;
  url: string;
}

export interface BdDistrict {
  id: string;
  division_id: string;
  name: string;
  bn_name: string;
  lat: string;
  lon: string;
  url: string;
}

export interface BdUpazila {
  id: string;
  district_id: string;
  name: string;
  bn_name: string;
  url: string;
}

export interface BdUnion {
  id: string;
  upazilla_id: string;
  name: string;
  bn_name: string;
  url: string;
}

interface BdApiResponse<T> {
  status: number;
  success: boolean;
  data: T;
}

async function fetchBdApi<T>(url: string): Promise<T> {
  const response = await fetch(url, { signal: AbortSignal.timeout(10_000) });
  if (!response.ok) {
    throw new Error(`BD API error: ${response.status} ${response.statusText}`);
  }
  const json: BdApiResponse<T> = await response.json();
  if (!json.success) {
    throw new Error('BD API returned unsuccessful response');
  }
  return json.data;
}

export const bdLocationService = {
  getDivisions: (): Promise<BdDivision[]> => {
    return fetchBdApi<BdDivision[]>(`${BASE_URL}/division`);
  },

  getDistrictsByDivision: (divisionId: string): Promise<BdDistrict[]> => {
    return fetchBdApi<BdDistrict[]>(`${BASE_URL}/district/${divisionId}`);
  },

  getUpazilasByDistrict: (districtId: string): Promise<BdUpazila[]> => {
    return fetchBdApi<BdUpazila[]>(`${BASE_URL}/upazilla/${districtId}`);
  },

  getUnionsByUpazila: (upazillaId: string): Promise<BdUnion[]> => {
    return fetchBdApi<BdUnion[]>(`${BASE_URL}/union/${upazillaId}`);
  },
};
